import { useState } from "react";

const faqs = [
  {
    q: "Do you cover emergency call-outs?",
    a: "Yes, where I can. If it's an immediate safety issue (sparks, burning smell, exposed live wires), turn off the power and call emergency services first — then send me a message and I'll come as soon as I can.",
  },
  {
    q: "Are you insured and qualified?",
    a: "Yes — fully qualified UK electrician, Part P registered, with public liability insurance. I'll happily share paperwork before any job.",
  },
  {
    q: "How does pricing work?",
    a: "Guide prices are on the pricing page. Once I've seen the job I'll give you a clear price before starting. No sneaky add-ons.",
  },
  {
    q: "Do you work with landlords?",
    a: "Absolutely. EICR safety certificates, remedial works and periodic inspections for local landlords are a big part of what I do.",
  },
  {
    q: "Can you help my small business?",
    a: "Yes — I work with local shops, cafés, salons and small offices. I focus on independent businesses rather than large commercial builds.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            FAQ
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-[1.05]">
            Quick answers,<br />
            <em className="not-italic text-accent-600">no jargon.</em>
          </h2>
          <p className="mt-4 text-foreground-600 max-w-sm">
            Something not listed here? Send a message and I'll get back to you as
            soon as I can.
          </p>
        </div>
        <div className="lg:col-span-8">
          <div className="rounded-2xl bg-background-100 border border-background-200 overflow-hidden">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q} className="border-b border-background-200 last:border-b-0">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-7 py-5 text-left cursor-pointer hover:bg-background-50 transition-colors"
                  >
                    <span className="text-base md:text-lg font-heading font-semibold text-foreground-950">
                      {f.q}
                    </span>
                    <span
                      className={`w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-800 transition-transform shrink-0 ${
                        isOpen ? "rotate-45 bg-accent-500 text-primary-950" : ""
                      }`}
                    >
                      <i className="ri-add-line text-lg"></i>
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-[max-height,opacity] duration-300 ${
                      isOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="px-5 md:px-7 pb-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
                      {f.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}